import { useMutation } from 'react-query'
import { notification } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { AxiosError } from 'axios'

import { AuthApi } from '@api'

const useChangePassword = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const { mutate: changePassword, isLoading } = useMutation(AuthApi.changePassword, {
    onSuccess: () => {
      notification.success({
        message: t('login.change_password_success'),
      })
      navigate('/login')
    },
    onError: (error: AxiosError) => {
      const message =
        error.response?.status === 401 ? t('login.link_expired') : t('login.change_password_error')
      notification.error({
        message,
      })
      navigate('/login/recover')
    },
  })

  return {
    changePassword,
    isLoading,
  }
}

export { useChangePassword }
